(function ($, Drupal, once) {
    'use strict';
    const behavior = 'deo_women_day.quote';
    Drupal.behaviors[behavior] = {
        attach: function (context) {
            if (context === document) {
                DEOWomenDayQuote(context);
            }
        }
    };
    const DEOWomenDayQuote = (context) => {
        const womendayQuote = $('.deo-womenday-quote');
        if (womendayQuote.length > 0) {
            once('DEOWomenDayQuoteInit', womendayQuote).forEach((element) => {
                $('header, .layout-container, .config_pages--type--header-block, .mtpc_header, .top-header, .header.sticky').removeClass('sticky').addClass('scrollable');
                $('.layout-container.scrollable').css('padding-top', 0);
                let position = $(window).scrollTop();
                let height = ($('.mtpc_header').outerHeight() - 15);
                const quoteText = $(element).find('.quotation-text');
                /*$(window).bind('scroll', function () {
                    let scroll = $(window).scrollTop();
                    if (scroll > position && scroll > height) {
                        //womendayQuote.addClass('scroll-active');
                    }
                    if (scroll < 40) {
                        womendayQuote.removeClass('scroll-active');
                        quoteText.animate(
                            {scrollTop: 0},
                            100
                        );
                    }
                    position = scroll;
                });*/
            });
        }
    };

})(jQuery, Drupal, once);